import React from 'react'
import { FormState } from './Aspects'

type Props = {
    formState: FormState[];
    currentAspectIndex: number;
}

const PreviewMiniComp: React.FC<Props> = ({
    formState,
    currentAspectIndex
}: Props) => {
    return (
        <div
            style={{
                width: "200px",
                height: "50px",
                overflow: "hidden",
                border: "1px solid #ccc",
                backgroundColor: "#000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0px",
                boxSizing: "border-box",
            }}
        >
            {formState.length > 0 && currentAspectIndex >= 0 && currentAspectIndex < formState.length && (
                <div
                    key={currentAspectIndex}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                    }}
                >
                    {formState[currentAspectIndex].pictogram !== "none" && (
                        <img
                            src={formState[currentAspectIndex].pictogram}
                            alt="Pictogram"
                            style={{
                                maxWidth: "30%",
                                maxHeight: "90%",
                                objectFit: "contain",
                                marginRight: "5px",
                            }}
                        />
                    )}
                    <div style={{ flex: 1, overflow: "hidden" }}>
                        {formState[currentAspectIndex].messages.map((message, i) => (
                            <p
                                key={i}
                                style={{
                                    textAlign: formState[currentAspectIndex].textAlign,
                                    fontSize: Math.min(formState[currentAspectIndex].textSize, 10) + "px", // Limita el tamaño del texto
                                    color: formState[currentAspectIndex].textColor,
                                    margin: "0",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textTransform: "uppercase"
                                }}
                            >
                                {message}
                            </p>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default PreviewMiniComp
